
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import authmodule from '@/store/authmodule'
import errormodule from '@/store/errorModule'
import rgpdmodule from '@/store/rgpdmodule'
import ofertasmodule from '@/store/ofertasmodule'
import encuestasmodule from '@/store/encuestasmodule'
import cvmodule from '@/store/CVmodule'
import candidaturasmodule from '@/store/candidaturasmodule'

import messages from '@/translations';
import dominios from '@/dominios';

let localhost = ['localhost', '192'];

let server = (!localhost.some(e => location.origin.includes(e))) ? location.origin : 'https://udp.esic.edu/';



// 1 BS 
// 2 UNIVERSIDAD

import appinfo from '../../package.json';

export const store = new Vuex.Store({
  state :{
    language: 'es',
    server : server,
    packageVersion : appinfo.version,
    type : 'bs'
  },
  actions :{

  },
  getters : {
    getServer : state => state.server,
    getTexts : state => {
      return messages[state.language];
    },
    getDominios : () => dominios,
    getVersion : state => state.packageVersion,
    getType : state => state.type
  },
  mutations : {
    setType(state,type){
      let types = {
        1 : "bs",
        2 : "uni"
      }

      state.type = types[type];
    }
  },
  modules :{
    errormodule,
    authmodule,
    rgpdmodule,
    ofertasmodule,
    encuestasmodule,
    cvmodule,
    candidaturasmodule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js